import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {AbstractValueAccessor, MakeProvider} from '../abstract-value-accessor';

@Component({
    selector: 'app-textarea-box',
    templateUrl: './textarea-box.component.html',
    styleUrls: ['./textarea-box.component.scss'],
    providers: [MakeProvider(TextareaBoxComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextareaBoxComponent extends AbstractValueAccessor {
  @Input() textBoxId: string;
  @Input() placeholder = '';
  @Input() errorText = '';
  @Input() labelText = '';
  @Input() formControlName = '';
  @Input() name = '';
  @Input() invalid = false;
  @Input() maxLength: number = 0;
  textLength: number = 0;
  @Input() showRemainingCharacters: boolean;
  @Input() source: string;

  propagateText($event: any): void {
    this.onChange($event.target.value);
  }

  changeEvent($event:any):void{
    this.textLength=$event.length;
    if(this.textLength === this.maxLength) {
      this.invalid = true;
    }
  }
}
